import React, { useEffect } from 'react'

import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import { PickingProductList } from '../../../Picking/Views/PickingProductList'

import { IPickingRoute } from '../../../../interfaces/PickingRoute/PickingRoute'

import usePickingRouteDetails from '../../../../hooks/usePickingRouteDetails'

import { Loading } from '../../../UI'

import { PickingRouteReviewTable } from '../../../Picking/Views/PickingRouteReview/PickingRouteReviewTable'
import { eTypePickingRoute } from '../../../../enums/eTypePickingRoute'

interface PickingRouteAdminReviewProps {
  pickingRoute: IPickingRoute | undefined
  reviewType?: number
  returnPreviousStep?: () => void
}

export const PickingRouteAdminReview: React.FC<
  PickingRouteAdminReviewProps
> = ({ pickingRoute, reviewType = 1 }) => {
  const {
    loading,
    error,
    productDetails,
    getPickingRouteProductDetails,
    getPickingRouteProductDetailsProgress
  } = usePickingRouteDetails()

  useEffect(() => {
    if (reviewType === 1) {
      getPickingRouteProductDetails(pickingRoute?.pickingRouteId || 0)
    } else if (reviewType === 2) {
      getPickingRouteProductDetailsProgress(pickingRoute?.pickingRouteId || 0)
    } else {
      getPickingRouteProductDetails(pickingRoute?.pickingRouteId || 0)
    }
  }, [getPickingRouteProductDetails, getPickingRouteProductDetailsProgress])

  if (loading) return <Loading />

  return (
    <Grid
      container
      spacing={3}
      direction='column'
      alignItems='center'
      justifyContent='center'
    >
      <Grid size={12}>
        <Typography variant='h5' component={Box} align='center'>
          {`Detalle Ruta ${
            pickingRoute?.typePickingRouteId === eTypePickingRoute.RTV
              ? `RTV${pickingRoute?.pickingRouteId}`
              : pickingRoute?.pickingRouteId
          }`}
        </Typography>
      </Grid>
      <Grid size={12}>
        <PickingRouteReviewTable
          error={error}
          productDetails={productDetails}
          ot={pickingRoute?.workOrderId!}
          typePickingRouteId={pickingRoute?.typePickingRouteId}
        />
      </Grid>
      <Grid size={12}>
        <PickingProductList pickingProductList={productDetails} />
      </Grid>
    </Grid>
  )
}
